import { useEffect, useState } from 'react';

const STORAGE_KEY = 'admin_impersonate_org_id';
const EVENT_NAME = 'admin-impersonation-change';

function readValue(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    return window.sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

/**
 * Allows a super-admin to "view as" a given organization.
 * Stored in sessionStorage so the override is dropped when the tab closes.
 */
export function useAdminImpersonation() {
  const [orgId, setOrgId] = useState<string | null>(() => readValue());

  useEffect(() => {
    const handler = () => setOrgId(readValue());
    window.addEventListener(EVENT_NAME, handler);
    window.addEventListener('storage', handler);
    return () => {
      window.removeEventListener(EVENT_NAME, handler);
      window.removeEventListener('storage', handler);
    };
  }, []);

  const startImpersonation = (id: string) => {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, id);
    } catch {
      // ignore storage errors
    }
    window.dispatchEvent(new Event(EVENT_NAME));
  };

  const stopImpersonation = () => {
    try {
      window.sessionStorage.removeItem(STORAGE_KEY);
    } catch {
      // ignore
    }
    window.dispatchEvent(new Event(EVENT_NAME));
  };

  return {
    impersonatedOrgId: orgId,
    isImpersonating: !!orgId,
    startImpersonation,
    stopImpersonation,
  };
}